import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useTheme } from "@mui/material";
import { useForm, FormContainer, FormErrorProvider } from "react-hook-form-mui";
import { BoxContainer } from "../layouts/Theme";
import PasswordField from "../partials/fields/PasswordField";
import ErrorAlert from "../partials/ErrorAlert";
import { useI18N } from "../context/I18NContext";
import { useFlow } from "../context/FlowContext";
import { useChangePassword } from "../hooks/query/useChangePassword";
import useWidgetStore from "../store/useWidgetStore";
export default function PasswordReset(props) {
    const { t } = useI18N();
    const theme = useTheme();
    const flow = useFlow();
    const [errors, setErrors] = useState();
    const [changed, setChanged] = useState(false);
    const formContext = useForm({});
    const changePasswordQuery = useChangePassword(formContext);
    const { consumer, setIsAccount, setIsGuest, setIsLoginAccount, setIsNewAccount, setConsumer } = useWidgetStore();
    useEffect(() => {
        if (consumer.hash && consumer.id) {
            formContext.setValue('hash', consumer.hash);
            formContext.setValue('id', consumer.id);
            setConsumer({});
            setIsAccount(false);
            setIsGuest(true);
            setIsLoginAccount(false);
            setIsNewAccount(false);
        }
    }, [consumer]);
    const onSubmit = (data, event) => {
        changePasswordQuery.refetch();
    };
    useEffect(() => {
        var _a;
        if ((_a = changePasswordQuery.data) === null || _a === void 0 ? void 0 : _a.status) {
            if (changePasswordQuery.data.status.status === 'failed') {
                setErrors(changePasswordQuery.data.status.userMessages);
                formContext.setError('password', { type: "value", message: t(changePasswordQuery.data.status.message, 'error') });
            }
            else {
                setChanged(true);
            }
        }
    }, [changePasswordQuery.data]);
    const onError = (errors) => { };
    const resumeLogin = () => {
        if (flow.onPrevious) {
            flow.onPrevious();
        }
    };
    return (_jsxs(BoxContainer, { children: [!changed && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary }, children: t('Nieuw wachtwoord instellen') }), _jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Om verder te gaan moet je een nieuw wachtwoord aanmaken.') }), _jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Je nieuwe wachtwoord moet aan de volgende regels voldoen: minimaal 8 tekens, ten minste 1 letter en ten minste 1 cijfer.') }), _jsxs(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: [_jsxs(FormErrorProvider, { onError: (error) => {
                                    var _a;
                                    if (error.type === 'validate') {
                                        console.log(error);
                                    }
                                    return t((_a = error.message) !== null && _a !== void 0 ? _a : error.type, 'error');
                                }, children: [_jsx(ErrorAlert, { messages: errors, setter: setErrors, noAutoClose: true }), _jsx(PasswordField, { label: t('Nieuw wachtwoord') })] }), _jsx(Button, { type: "submit", fullWidth: true, sx: { my: 1 }, variant: "contained", children: t('Wachtwoord aanpassen') })] })] })), changed && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary }, children: t('Je wachtwoord is aangepast') }), _jsx(Typography, { variant: "body1", sx: { color: theme.palette.text.primary, my: 1 }, children: t('Je kunt nu inloggen met je nieuwe wachtwoord.') }), _jsx(Button, { fullWidth: true, sx: { my: 1 }, variant: "contained", onClick: resumeLogin, children: t('Verder met inloggen') })] }))] }));
}
